
import { Route, Routes } from 'react-router-dom';
import Login from './pages/Login';
import CastcoLogin from './pages/Login/CastcoLogin';
import { useContext, useEffect, useState } from 'react';
import './style.scss';
import './App.css';
import { GlobalStateContext } from './store/GlobalState';
import SteelBarForm from './pages/Form/SteelBarForm';
import FormList from './pages/Form/FormList';
import SteelBarFormView from './pages/Form/SteelBarFormView';
import api from './app/api/agent';
import { toast } from 'react-toastify';
import UserInfo from './pages/Admin/UserInfo';
import Loading from './pages/Login/loadingPage';
import Cookies from 'js-cookie';
import ApprovalList from './pages/Admin/ApprovalList';
import AlertList from './pages/Admin/AlertList';
import AlertEdit from './pages/Admin/AlertEdit';
import AdminList from './pages/Admin/AdminList';
import SteelBarFormEdit from './pages/Form/SteelBarFromEdit';
import ForgotPassword from './pages/Login/forgotPassword';

enum userRoleList {
    CustomerService,                
    CastcoEmployee,
    Customer
}

function App() {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [userRole, setUserRole] = useState<string | null>(null);
  const globalState = useContext(GlobalStateContext);


  const isLoggedIn = (localStorage.accessToken && globalState?.accessToken !== "") || (Cookies.get(".AspNetCore.CookiesC1") !== undefined || Cookies.get(".AspNetCore.CookiesC1") !== "{}");

  useEffect(() => {

    const token = localStorage.accessToken;

    if (token) {
      try {
          api.get(`/Account/userInfo`).then((response)=>{
                  if (response.status !== 200){
                      toast.error("You have to login, login expired")
                  }else{
                    setUserRole(userRoleList[response.data.role.toString()])
                    localStorage.setItem("role", userRoleList[response.data.role])
                  }
                  }).catch(()=>{
                      toast.error("You have to login, login expired")
                  })
        /* // Decode the JWT
        const decoded = decodeJWT(token);
        if (decoded) {
          setUserRole(decoded.Role); // Extract the role
          localStorage.setItem('role', decoded.Role);
        } */
      } catch (error) {
        //console.error('Invalid JWT:', error);
      }
    }else{
      api.get("/OIDC/getUserInfo",{withCredentials: true,}).then((response)=>{
                    if (response.status !== 200){
                    }else{
                      setUserRole(userRoleList[response.data.role.toString()])
                      localStorage.setItem("role", userRoleList[response.data.role])
                    }
                    }).catch(()=>{
                })
    }
  }, []);

  return (
    <GlobalStateContext.Provider value={globalState}>
      {/* <Router> */}
      <Routes>
        {(window.location.pathname === '/' || window.location.pathname === '/Castcologin' || window.location.pathname.includes('/reset-password')) && (<>
        <Route path="/" element={<Login />} />
        <Route path="/reset-password/:token" element={<ForgotPassword />} />
        <Route path="/Castcologin" element={<CastcoLogin />} /></>)}
        
        {isLoggedIn && window.location.pathname !== '/' && window.location.pathname !== '/Castcologin' && (<>
        <Route path="/form" element={<SteelBarForm />} />
        <Route path="/form/view" element={<SteelBarFormView />} />
        <Route path="/form/edit" element={<SteelBarFormEdit />} />
        <Route path="/admin/list" element={<AdminList />} />
        <Route path="/approve/list" element={<ApprovalList />} />
        {/* <Route path="/admin/list" element={<ApprovalList />} /> */}
        <Route path="/alert/list" element={<AlertList />} />
        <Route path="/alert/edit" element={<AlertEdit />} />
        <Route path="/form/list" element={<FormList />} />
        <Route path="/userinfo" element={<UserInfo />} /></>)}

        {!isLoggedIn && window.location.pathname !== '/' && window.location.pathname !== '/Castcologin' && (
            window.location.href='/' 
        )}

        <Route path="/loading" element={<Loading />} />
        {/* 
        <Route path="/form" element={<SteelBarForm />} />
        <Route path="/form/edit" element={<SteelBarFormEdit />} /> */}

      </Routes>
      {/* </Router> */}
    </GlobalStateContext.Provider>
  );
}

export default App;
